export default Vue.extend({
  props: {
    uploadRequest: {
      type: Boolean,
    },
    requestSuccess: {
      type: Boolean,
    },
    file: {
      type: File,
    },
    requestError: {
      type: Boolean,
    },
  },

  template: `
    <div>
      <div class="upload-mask" v-if="uploadRequest && requestError" @click="closeUploadMask">
        <div class="upload-results">
          <i class="result-icon slp-times-circle-o error-text"></i>
          <div class="mt-4 gray-text text-center">文件上传失败<br/>请重试</div>
        </div>
      </div>

      <div class="modal-body">
        <slot name="modalField"></slot>
        <div class="upload-results content-center" v-if="requestSuccess">
          <i class="result-icon slp-check-circle-o success-text"></i>
          <div class="mt-4">文件上传成功<br/>数据导入中...</div>
          <div class="mt-4 gray-link">
            数据导入结果请在“
            <slot name="importRecords"></slot>
            ”页面进行查看
          </div>
        </div>
        <div class="content-center" v-else>
          <div class="upload-template-container justify-box centered">
            <div class="upload-template-center">
              <div>
                <label class="btn btn-primary outlined large">
                  <span>选择 Excel 文件</span>
                  <slot name="fileUpload"></slot>
                </label>
              </div>
              <slot name="tips"></slot>
              <div class="attachments-container">
                <div class="attachment-list">
                  <div class="attachment-item mt-4" v-if='file'>
                    <div class="attachment-type">
                      <div class="content-centered">
                        <file-icon :type='"excel"' size='mini' />
                      </div>
                    </div>

                    <div class="attachment-details vertical-middle">
                      <span class="attachment-name text-ellipsis">{{ file.name }}</span>
                      <span class="attachment-size ml-2">({{ file.size }}k)</span>
                    </div>
                    <div class="attachment-actions">
                      <div class="btn icon-btn link-btn" @click='removeFile'>
                        <i class="slp-trash"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <slot name="downloadTemplate"></slot>
        </div>
      </div>
    </div>
  `,

  methods: {
    removeFile() {
      this.$emit('removeFile');
    },

    closeUploadMask() {
      this.$emit('closeUploadMask');
    },
  },
});
